import React from 'react'
import { CircularProgress, Box } from '@mui/material'

const LoadingSpinner = ({ center = false, size = 'medium' }) => {
    const sizeMap = {
        small: 20,
        medium: 40,
        large: 60
    }

    const spinner = (
        <CircularProgress
            size={sizeMap[size]}
            sx={{
                color: 'primary.main',
            }}
        />
    )

    if (center) {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="200px"
            >
                {spinner}
            </Box>
        )
    }

    return spinner
}

export default LoadingSpinner
